export default function (state = {
	isOpen: false,
}) {
	return {
		isOpen: state.isOpen,
		activeNodeId: null,

		init() {
			this.events()
			this.resize()
			this.menuOverflow()
		},

		events() {
			window.addEventListener('primary-menu:toggle', () => {
				this.toggle()
			})

			window.addEventListener('keyup', (event) => {
				if (event.key === 'Escape' && this.isOpen) {
					this.toggle()
				}
			})
		},

		resize() {
			if (!this.$refs.wrapper) {
				return
			}

			new ResizeObserver(() => {
				if (
					!this.isOpen
					|| window.innerWidth < 1024
				) {
					return
				}

				this.toggle()
			}).observe(this.$refs.wrapper)
		},

		toggle() {
			this.isOpen = !this.isOpen

			if (!this.isOpen) {
				document.body.classList.remove('has-overlay')
				this.activeNodeId = null
			}
			else {
				document.body.classList.add('has-overlay')
			}
		},

		setActiveNodeId($event, id) {
			if (window.innerWidth >= 1024) {
				return
			}

			$event.preventDefault()
			this.activeNodeId = id
		},

		menuOverflow() {
			if (
				!this.$refs.overflow
				|| !this.$refs.wrapper
			) {
				return
			}

			const overflow = this.$refs.overflow
			const wrapper = this.$refs.wrapper
			const items = wrapper.querySelectorAll(':scope > li:not([x-ref="overflow"])')
			const overflowItems = overflow.querySelectorAll('ul > li')
			let wrapperWidth = null

			new ResizeObserver((entries) => {
				const menu = entries[0]
				if (!menu.borderBoxSize || !menu.borderBoxSize[0]) {
					return
				}

				const borderBoxSize = menu.borderBoxSize[0].inlineSize ?? null
				if (borderBoxSize === null || borderBoxSize === wrapperWidth) {
					return
				}

				wrapperWidth = borderBoxSize

				let itemsWidth = 0
				let itemsShown = 0
				items.forEach((item) => {
					item.classList.remove('lg:hidden')
					itemsWidth += item.clientWidth

					if (itemsWidth > wrapperWidth) {
						item.classList.add('lg:hidden')
					}
					else {
						itemsShown += 1
					}
				})

				if (itemsShown < items.length) {
					items[itemsShown - 1]?.classList?.add('lg:hidden')
					overflow.classList.add('lg:block')
				}
				else {
					overflow.classList.remove('lg:block')
				}

				overflowItems.forEach((item, index) => {
					if (index >= itemsShown - 1) {
						item.classList.remove('hidden')
					}
					else {
						item.classList.add('hidden')
					}
				})
			}).observe(wrapper)
		},
	}
}
